import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import {  Container, Image } from 'semantic-ui-react'
// import { Link } from 'react-router-dom'
import { CloudIconStatic } from '../partials/CloudIcon'
import DocumentTitle from 'react-document-title';

const STYLES = `
body {
  background: linear-gradient( #006ab9, #00acfe );
}`

class Home extends Component {

  // state = { }


  render() {

  return (
    <DocumentTitle title='Blue Sky Paint'>
    <Container className='home'>
    <style>{STYLES}</style>
      <CloudIconStatic />
      <p><a className="kitty-png" href="https://www.producthunt.com/posts/blue-sky-paint"><Image centered src={`/images/kitty.png`} /></a></p>
      <p><a className="download-button" href="https://itunes.apple.com/us/app/blue-sky-paint/id1402794313?mt=8"><Image centered width={220} src={`/images/ios_appstore.gif`} /></a></p>
      <p className="presskit-button ui inverted centered" ><a className="download-button ui inverted centered" href="https://paper.dropbox.com/doc/Blue-Sky-Paint--AL4nDMrkQ60FLSwRbuBRX2mOAg-XwLzJ7UG6fuiCproL8zPf">Press Kit</a></p>
    </Container>
    </DocumentTitle>
  )

  }
}


export default compose(
  firebaseConnect(), // withFirebase can also be used
  connect(({ firebase: { auth } }) => ({ auth }))
)(Home)



// WEBPACK FOOTER //
// ./src/components/pages/Home.js